<template>
  <div class="content flex my-4">
    <div class="auth-form mx-auto my-auto">
      <div class="card">
        <div class="card-body">
          <h1 class="heading-bigger mb-4 text-center">{{ $t('registerMailSent.sendMessage') }}</h1>

          <p class="my-5 text-center">
            {{ $t('registerMailSent.sendMessageToEmail') }}
          </p>

          <div class="text-center mt-4">
            <router-link
              to="/logowanie"
              class="lnk lnk-big lnk-big-blue">
              {{ $t('ui.backToLoginPage') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register-mail-sent'
};
</script>
